<template>
    <div>
        <div class="training-course-list _commercial-webinars">
            <a class="training-course-list-item _add-new" v-if="user_can_manage_courses" href="/commercial/training/create">
                <div class="box">
                    <div class="image">
                        <i class="fal fa-plus"></i>
                    </div>
                    <div class="content">
                        <div class="title">
                            Add a new course
                        </div>
                    </div>
                </div>
            </a>
            <div class="training-course-list-item" v-for="course in courses">
                <div class="box">
                    <div class="image">
                        <img :src="`${$aws_bucket_url}${course.image_url}`">
                    </div>
                    <div class="content">
                        <div class="title">
                            {{ course.title }}
                        </div>
                        <div class="mt-3">
                          <i class="fal fa-building" v-if="course.commercial_training_course_type_id === 3"></i>
                          <i class="fal fa-video" v-if="course.commercial_training_course_type_id === 2"></i>
                          <i class="fal fa-presentation" v-if="course.commercial_training_course_type_id === 1"></i>
                          {{ course.commercial_training_course_type.label }}
                        </div>
                        <div class="description" v-html="course.summary"></div>
                    </div>
                    <div class="footer">
                        <div class="buttons">
                            <a class="btn-primary" :href="`/commercial/training/${course.id}`">
                                Learn More
                            </a>
                          <a class="btn-danger ml-2" @click="deleteCourse(course.id)" v-if="user_can_manage_courses">
                            Delete
                          </a>
                            <a class="btn-primary ml-2" :href="`/commercial/training/edit/${course.id}`" v-if="user_can_manage_courses">
                                Edit
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="total_count > 10">
            <div class="pagination-bar wrapper mb-3 mt-3">
                <div class="row">
                    <div class="col">
                        <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                            class="fa fa-caret-left"></i></a>
                        <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                        <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                           class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                    </div>
                    <div class="col align-right">
                        <div class="mt-1 mb-1">
                            {{ total_count }} results found
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    mounted() {
        this.loadCourses();
    },
    data() {
        return {
            courses: [],
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            deleting_course: false,
        }
    },
    props: [
      'logged_in_user',
      'user_can_manage_courses',
    ],
    methods: {
        loadCourses() {
            axios.post('/commercial/training/loadCourses', {
                page_number: this.current_page,
            }).then((response) => {
                this.courses = response.data.data;
                this.total_count = response.data.total;
                this.total_pages = response.data.last_page;
            });
        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadCourses();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadCourses();
        },
      deleteCourse(course_id) {
        Swal.fire({
          title: 'Are you sure you want to remove this course?',
          text: 'This action cannot be undone.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          this.deleting_course = true;
          if (result.isConfirmed) {
            axios.post('/commercial/training/delete-course', {
              course_id: course_id,
            }).then(() => {
              Swal.fire({
                'title': 'Course Deleted',
                'icon': 'success',
              });
              this.current_page = 1;
              this.loadCourses();
              this.deleting_course = false;
            });
          }
        });
      },
    },
}
</script>
